import { render, staticRenderFns } from "./SettingList.vue?vue&type=template&id=053fe537&"
import script from "./SettingList.vue?vue&type=script&lang=js&"
export * from "./SettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports